// Mock data for Agri Direct Australia website

export const companyInfo = {
  name: "Agri Direct Australia",
  shortName: "ADA",
  tagline: "Connecting Australian Farmers to the World",
  description: {
    intro: "Agri Direct Australia partner with Australian farmers and connect them directly with our close network of wholesalers in markets all over the world.",
    model: "Agri Direct Australia's model focuses on adding value to the supply chain by bringing farmers, wholesalers and the consumer closer together, while minimising operational costs. This approach allows Agri Direct Australia to pass on cost savings to our member farmers and wholesalers.",
    exports: "ADA exports Australian wheat, chickpeas, lentils, canola, oats and other Australian agricultural products to overseas destinations including South East Asia, Middle East by containers and bulk shipment. We form close partnership with growers and wholesalers to reduce costs and mitigate risks, by ensuring the highest standards from end-to-end in the export process.",
    values: "We value our relationships above all else, and our customers and growers know they can trust the quality and professionalism that underpins everything we do at Agri Direct Australia."
  },
  copyright: "© 2014 ADA Agri Direct Australia. All rights reserved."
};

export const heroSlides = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/kkocva12_Home01.jpg",
    alt: "Agri Direct Australia - Agricultural Export"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/za8rqx83_Home02.jpg",
    alt: "ADA Agricultural Export - Supply Chain"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1600&h=500&fit=crop",
    alt: "Farming machinery in field"
  }
];

export const navigationItems = [
  { id: 1, label: "HOME", href: "/", active: true },
  { id: 2, label: "ABOUT US", href: "/about" },
  { id: 3, label: "PRODUCTS", href: "/products" },
  { id: 4, label: "CONTACT", href: "/contact" }
];

export const productCategories = [
  {
    id: 1,
    name: "Wheat",
    icon: "wheat",
    href: "/products#wheat",
    color: "#d4a574"
  },
  {
    id: 2,
    name: "Cotton",
    icon: "cloud",
    href: "/products#cotton",
    color: "#f5f5f5"
  },
  {
    id: 3,
    name: "Pulse",
    icon: "circle-dot",
    href: "/products#pulse",
    color: "#8b7355"
  }
];

export const products = [
  {
    id: 1,
    name: "Wheat",
    slug: "wheat",
    description: "Premium Australian wheat varieties including APH, APW, ASW, and feed wheat. Our wheat meets international quality standards and is exported globally.",
    image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=600&h=400&fit=crop",
    features: ["High protein content", "Superior milling quality", "Consistent grading", "Bulk & container options"]
  },
  {
    id: 2,
    name: "Chickpeas",
    slug: "chickpeas",
    description: "Australian chickpeas are renowned for their quality. We export both Desi and Kabuli varieties to markets in South Asia and the Middle East.",
    image: "https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/w6pfa9th_Chickpeas.jpg",
    features: ["Desi & Kabuli varieties", "High protein content", "Clean & graded", "Export certified"]
  },
  {
    id: 3,
    name: "Lentils",
    slug: "lentils",
    description: "Premium quality Australian lentils including red and green varieties. Sourced directly from trusted Australian growers.",
    image: "https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/u1bo3j8c_Lentils.jpg",
    features: ["Red & green lentils", "Excellent cooking quality", "Competitive pricing", "Reliable supply"]
  },
  {
    id: 4,
    name: "Canola",
    slug: "canola",
    description: "High-quality Australian canola for oil production. Our canola meets stringent international specifications.",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b?w=600&h=400&fit=crop",
    features: ["High oil content", "Low erucic acid", "Non-GMO available", "Bulk shipment"]
  },
  {
    id: 5,
    name: "Oats",
    slug: "oats",
    description: "Premium Australian oats suitable for food, feed and milling purposes. Consistent quality year-round.",
    image: "https://images.unsplash.com/photo-1614961233913-a5113a4a34ed?w=600&h=400&fit=crop",
    features: ["Food & feed grade", "Milling oats", "High beta-glucan", "Consistent supply"]
  },
  {
    id: 6,
    name: "Cotton",
    slug: "cotton",
    description: "Australian cotton is known worldwide for its exceptional quality, length and strength characteristics.",
    image: "https://images.unsplash.com/photo-1616431101491-554c0932ea40?w=600&h=400&fit=crop",
    features: ["Long staple length", "High strength", "Excellent uniformity", "Premium quality"]
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "Record Wheat Harvest Expected This Season",
    date: "November 5, 2023",
    excerpt: "Australian farmers are anticipating one of the largest wheat harvests in recent years, with favorable weather conditions contributing to excellent crop development.",
    image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400&h=300&fit=crop"
  },
  {
    id: 2,
    title: "New Export Partnership with Asian Markets",
    date: "October 20, 2023",
    excerpt: "Agri Direct Australia announces expanded partnerships with wholesalers in Southeast Asian markets, opening new opportunities for Australian growers.",
    image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=400&h=300&fit=crop"
  },
  {
    id: 3,
    title: "Sustainable Farming Practices Initiative",
    date: "October 8, 2023",
    excerpt: "ADA launches new initiative to support sustainable farming practices among partner growers, focusing on environmental stewardship and quality improvement.",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400&h=300&fit=crop"
  }
];

export const contactInfo = {
  address: "",
  phone: "+61 3 9818 4690",
  fax: "+61 3 9576 1815",
  email: "Info@agridirect.com.au",
  hours: "09:00 - 18:00"
};

export const footerLinks = {
  usefulLinks: [
    { name: "Weather", url: "https://www.bom.gov.au/climate/outlooks/#/rainfall/median/weekly/0" },
    { name: "Grain Trade Australia", url: "https://www.graintrade.org.au/" },
    { name: "Australian Cotton Shippers Association", url: "https://austcottonshippers.com.au/" },
    { name: "Pulse Australia", url: "https://www.pulseaus.com.au/" }
  ],
  pulseAustralia: {
    memberText: "ADA is a proud member of Pulse Australia",
    logo: "https://www.pulseaus.com.au/storage/app/media/pulse-australia-logo.png",
    url: "https://www.pulseaus.com.au/"
  }
};
